<template>
  <section class="gallery-wrap">
    <div class="home-page-container"></div>
    <div class="container">
      <div class="heading"></div>

      <div class="campaign-footer" @click="handleBannerClick">
        <!-- <video autoplay muted loop>
          <source
            src="../../assets/rupakotcampaign-video-footer.webm"
            type="video/webm"
          />
        </video> -->

        <img
          v-show="this.slimBanner"
          :src="this.slimBanner"
          alt="slim_banner_image"
        />
      </div>

      <div class="demo menu-list-content">
        <div class="listSection" v-for="list in rawList" :key="list.id">
          <span class="list-title">{{ list.title }} </span>

          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide
              class="menu-list"
              v-for="data in list.list_items"
              :key="data.id"
            >
              <HomePageProduct
                v-bind:item="data"
                :key="data.id"
                v-on:view-product="viewProduct($event)"
              />
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>

      <div
        class="demo menu-list-content"
        v-if="staticList !== 'No items found'"
      >
        <div class="listSection" v-for="list in staticList" :key="list.id">
          <span class="list-title">{{ list.title }} </span>

          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide
              class="menu-list"
              v-for="data in list.list_items"
              :key="data.id"
            >
              <HomePageProduct
                v-bind:item="data"
                :key="data.id"
                v-on:view-product="viewProduct($event)"
              />
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>

      <!-- <div class="demo menu-list-content">
        <div class="listSection" v-for="list in rawList" :key="list.id">
          <span class="list-title">{{ list.title }}  </span>

          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide
              class="menu-list"
              v-for="data in list.list_items"
              :key="data.id"
            >
              <HomePageProduct
                v-bind:item="data"
                :key="data.id"
                v-on:view-product="viewProduct($event)"
              />
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div> -->
    </div>

    <div v-if="popUpOn">
      <ProductPopup
        :item="popupProduct"
        v-on:close-popup="closePopup($event)"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import {
  HomePageListService,
  GetBannerService,
  HomePageListServiceStatic,
} from "../../services/items.service";
import { LocationId } from "../../services/storage.service";
import Product from "../Home/ProductFeature/Product";
import HomePageProduct from "../Home/ProductFeature/HomePageProduct";
import router from "../../router";

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import ProductPopup from "../../views/Home/ProductFeature/ProductPopup.vue";
import { data } from "../Checkout/data";

export default {
  name: "HomePageList",
  components: {
    Product,
    Swiper,
    SwiperSlide,
    ProductPopup,
    HomePageProduct,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      slimBanner: "",
      visibleSlide: 0,
      popUpOn: 0,
      popupProduct: [],
      direction: "left",
      pageName: "",
      showFilterCat: 1,
      loading: false,
      categories: [],
      subCategories: [],
      items: [],
      allItems: [],
      visible1: false,
      currentTag: "",
      typeTag: "",
      rawList: {},
      staticList: [],
      currentCat: "",
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          320: {
            slidesPerView: 2,
            slidesToShow: 2,
            spaceBetween: 30,
          },
        },
      },
    };
  },
  created() {
    this.loadBanner();
    this.checkParams();
    this.clearVariables();

    this.currentTag = this.currentTag.toLowerCase();

    if (LocationId.getLocationId() === null) {
      return;
    } else {
      this.loadServices();
      this.loadServicesStatic();
    }
  },
  watch: {
    $route: function (n, o) {
      this.checkParams();
      this.loadServices();
      this.clearVariables();
    },

    locationId: function (newLocationId, oldLocationId) {
      this.loadServices();
    },
    currentLocation(){
      this.loadServicesStatic();
    }
  },
  computed: {
    ...mapGetters(["locationId", "tokenUser", "currentLocation"]),
    filteredItems: function () {
      var filter = this.currentTag.toLowerCase();
      if (filter === "combo") {
        return this.items.filter(function (item) {
          return item.item_type.toLowerCase().indexOf(filter) !== -1;
        });
      } else {
        return this.items.filter(function (item) {
          return item.cat_id.toLowerCase().indexOf(filter) !== -1;
        });
      }
    },
    emptyCategoryList: function () {
      return this.categories.filter(function (item) {
        return item.cat_id !== "";
      });
    },
    emptySubCategoryList: function () {
      let a = this;
      return this.categories.filter(function (item) {
        return item.name == a.currentTag;
      });
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    slidesLen() {
      return this.slides.length;
    },
  },
  mounted() {
    console.log("Current Swiper instance object", this.swiper);
    this.swiper.slideTo(3, 1000, false);
  },
  methods: {
    ...mapActions(["setMinOrder"]),

    loadBanner: function () {
      GetBannerService.getItems(LocationId.getLocationId(), "")
        .then((response) => {
          let slim = response.data.filter((data) => data.type === "slim");
          this.slimBanner = slim[0].image;
        })
        .catch((err) => console.log(err));
    },

    showFilter() {
      this.visible1 = true;
    },
    onClose() {
      this.visible1 = false;
    },
    handleChange(value) {
      return;
    },
    handleBlur() {
      return;
    },
    handleFocus() {
      return;
    },
    onSearch(e) {
      this.currentTag = "";
      this.typeTag = "";
      this.items = this.allItems.filter((item) =>
        item.name.toLowerCase().includes(e.target.value.toLowerCase())
      );

      if (e.target.value.length > 0) {
        this.showFilterCat = 0;
      } else {
        this.showFilterCat = 1;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterTags: function (tag) {
      this.items = this.allItems;
      this.currentTag = tag;
      this.typeTag = "";

      this.showFilterCat = 0;
    },
    filterTags2: function (tag) {
      this.items = this.allItems;

      this.typeTag = "";
      // this.showFilterCat = 0;
      this.currentCat = tag;
      this.secondFilter(tag);
    },
    secondFilter: function (tag) {
      this.typeTag = tag;
      if (tag === "") {
        this.items = this.allItems;
      } else {
        this.items = this.allItems.filter((item) => item.sub_cat_id === tag);
      }

      this.showFilterCat = 0;
    },

    checkParams: function () {
      //    console.log("::" + this.$route.params.slug )
      this.pageName = this.$route.params.slug;

      if (this.$route.params.slug != undefined) {
        this.hasV = 1;
        //if Number
        if (!isNaN(this.vName)) {
          // console.log("Number : " + Number(this.vName));
        }
        // endif NaN
        //if String
        else {
          // console.log("String : " + this.vName)
        }
        // end isnan strings
      } else {
        this.hasV = 0;
        // router.push("/");

        if (LocationId.getLocationId() == 1) {
          router.push("/ktm");
        } else if (LocationId.getLocationId() == 2) {
          router.push("/pkr");
        }
      }
    },

    loadServicesStatic: function () {
      HomePageListServiceStatic.getItems(LocationId.getLocationId())
        .then((res) => {
          // console.log(res, "res on static load service before");
          if (res.error == false) {
            this.staticList = res.data;
            // console.log(
            //   "loadServicesStatic[HomePageListServiceStatic]",
            //   res.data
            // );
          }
        })
        .catch((err) => console.log(err));
    },

    loadServices: function () {
      const user_id = JSON.parse(localStorage.getItem("user_id"));
      HomePageListService.getItems(LocationId.getLocationId(), user_id)
        .then((data) => {
          this.rawList = data;
        })
        .catch((err) => console.log(err));
    },

    clearVariables: function () {
      this.currentCat = "";
      this.currentTag = "";
      this.typeTag = "";
    },

    next() {
      if (this.visibleSlide >= this.slidesLen - 1) {
        this.visibleSlide = 0;
      } else {
        this.visibleSlide++;
      }
      this.direction = "right";
    },

    prev() {
      if (this.visibleSlide <= 0) {
        this.visibleSlide = this.slidesLen - 1;
      } else {
        this.visibleSlide--;
      }
      this.direction = "left";
    },

    viewProduct(product) {
      this.popupProduct = product;
      this.popUpOn = 1;
      // alert(this.popupProduct);
    },

    closePopup() {
      this.popUpOn = 0;
    },

    handleBannerClick() {
      // router.push("/3");
      // window.location.href = "https://khaanpin.com/3";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.gallery-wrap {
  padding-top: 0px !important;
}

.ant-spin-dot {
  font-size: 50px;
  width: 50px;
  height: 50px;
  i {
    width: 25px;
    height: 25px;
  }
}

.gallery-wrap {
  .container {
  min-height: 30vh;
  }
  .item-search {
    width: 300px !important;
    input {
      padding: 5px 20px;
      padding-right: 50px;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      border-radius: 100px;
      border-color: #b1b1b1;
      color: #999999;
      &::-webkit-input-placeholder {
        color: #999999;
      }
    }
    .ant-input-suffix {
      right: 20px;
      i {
        font-size: 18px;
      }
    }
  }
}

.menu-list-content {
  .filter-part {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-family: $main-font;
    margin: 30px 0 70px;
    .filter {
      cursor: pointer;
      i {
        padding-right: 8px;
      }
      font-size: 16px;
      color: #282828;
      font-weight: 500;
      margin-right: 40px;
    }
    .sort {
      font-size: 16px;
      color: #8b8b99;
      display: inline-block;
      .ant-select {
        margin-left: 10px;
      }
    }
  }
}

.filter-content {
  padding: 15px 80px 60px;
  .cross {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    .img-wrap {
      width: 18px;
    }
  }
}

.demo {
  .button-group {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 0px;
    button {
      height: 30px;
      margin-bottom: 10px;
      line-height: 28px;
      border: 1px solid #e7e9f3;
      font-size: 13px;
      font-weight: 600;
      border-radius: 30px;
      -moz-background-clip: padding;
      -webkit-background-clip: padding-box;
      background-clip: padding-box;
      padding: 0 20px;
      text-transform: uppercase;
      background-color: transparent;
      -ms-transition: all 500ms ease;
      -webkit-transition: all 500ms ease;
      transition: all 500ms ease;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #fff;
        background-color: $brand-color;
      }
      &:hover {
        color: #fff;
        background-color: $brand-color;
      }
      &:focus {
        outline: none;
      }
    }
    &.secondary-filter {
      padding-top: 15px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        top: 0;
        width: 65%;
        height: 1px;
        background: #eaeaea;
        transform: translate3d(-50%, 0, 0);
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .gallery-wrap {
    .item-search {
      input {
        height: 38px;
        line-height: 38px;
      }
    }
  }
  .menu-list-content {
    .filter-part {
      .sort {
        margin-top: 13px;
      }
    }
  }
  .filter-content {
    padding: 15px 20px 30px;
  }
}
@media only screen and (max-width: 575px) {
  .gallery-wrap {
    .item-search {
      margin-bottom: 20px;
      input {
        height: 35px;
        line-height: 35px;
      }
    }
  }
  .menu-list {
    max-width: 350px;
    margin: 50px auto 0;
  }
  .menu-list-content {
    .filter-part {
      margin: 15px 0 50px;
      .filter {
        margin-right: 20px;
        font-size: 14px;
      }
      .sort {
        margin: 0;
        .info {
          display: none;
        }
        .ant-select {
          margin-left: 0;
          width: 150px !important;
        }
      }
    }
  }
  .demo {
    .button-group {
      button {
        height: 28px;
        line-height: 20px;
        font-size: 12px;
        margin-right: 10px;
        padding: 0 15px;
        text-transform: capitalize;
      }
    }
  }
}
@media only screen and (max-width: 425px) {
  .gallery-wrap {
    .item-search {
      width: 100% !important;
      max-width: 250px;
    }
  }
  .menu-list-content {
    .filter-part {
      margin: 10px 0 40px;
      .filter {
        margin-right: 0px;
      }
    }
  }
  .filter-content {
    padding: 15px 10px 15px;
  }
}

.tagBtn button {
  height: inherit !important;
  border: none !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border-radius: 0px !important;
  background-clip: padding-box !important;
  padding: 3px 18px !important;
  text-transform: uppercase !important;
  -webkit-transition: all 500ms ease !important;
  transition: all 500ms ease !important;
  margin-right: 0px !important;
  margin-bottom: 7px !important;
  border-right: 1px dashed #ccc !important;
}

.showFilterBar {
  display: block;
  position: relative;
  margin-top: 20px;
  .line {
    border-bottom: 1px dashed #ffffff;
  }
  .text {
    cursor: pointer;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    padding: 8px 20px;
    margin: 0 auto;
    background: #ed3c3b;
    color: #fff;
    letter-spacing: 2px;
    font-size: 12px;
    border-radius: 200px;
    margin-left: 50%;
    transform: translate(-50%, -50%);
    border: 4px solid #fff;
  }
}
.vname {
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;

  span {
    margin: 0;
    font-size: 15px;
    text-transform: uppercase;
    font-weight: bold;
  }
}

.product {
  .image-wrap {
    border-radius: 10px !important;
  }
}

.filters {
  padding: 30px 0px;
  padding-top: 10px;
  background: #fff;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.2);

  .closeBtn {
    color: rgb(241, 83, 83);
    position: absolute;
    right: 10px;
    top: 10px;
    font-weight: bold;
    cursor: pointer;
  }
}

.listSection {
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;

  .menu-list {
    margin-top: 0px;
  }
  .list-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    display: inline-block;
    color: #ec3934;
  }
  .ant-item-list {
    margin: 0;
  }
  .product {
    margin-bottom: 0;
    .product-info {
      padding-bottom: 0;
    }
  }
}

.swiper-button-prev {
  position: absolute;
  top: 50%;
  // width: calc(var(--swiper-navigation-size) / 44 * 27);
  // height: var(--swiper-navigation-size);
  /* margin-top: calc(-1 * var(--swiper-navigation-size) / 2); */
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ec3934;
  left: 0;
  outline: none;
}

.swiper-button-next {
  position: absolute;
  top: 50%;
  // width: calc(var(--swiper-navigation-size) / 44 * 27);
  // height: var(--swiper-navigation-size);
  /* margin-top: calc(-1 * var(--swiper-navigation-size) / 2); */
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ec3934;
  right: 0;
  outline: none;
}

.swiper-button-prev:after {
  font-family: swiper-icons;
  font-size: 26px;
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
  outline: none;
}

.swiper-button-next:after {
  font-family: swiper-icons;
  font-size: 28px;
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
  left: 0;
  outline: none;
}

.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  outline: none;
}

.swiper-pagination-bullet-active {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ec3934;
  opacity: 1;
  outline: none;
}

.campaign-footer {
  border-radius: 10px;
  margin-bottom: 30px;
  margin-top: 22px;
  height: auto;
  width: auto;

  video {
    border-radius: 10px;
    height: 100%;
    width: 100%;
    object-fit: fill;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  }

  img {
    border-radius: 10px;
    height: 200px;
    width: 100%;
    // object-fit: cover;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  }
}

@media only screen and (max-width: 1200px) {
  .gallery-wrap {
    margin-top: 164px;
  }

  .home-page-container {
    margin-top: -120px;
  }
}

// remove later (css for 5 items in banner)
@media only screen and (max-width: 1024px) {
  .campaign-footer {
    margin-top: 200px;
  }
}

@media only screen and (max-width: 740px) {
  .campaign-footer {
    margin-top: 200px;
  }
}
</style>
